<template>
	<div :class="classes">
		<OneOnOneListHeaderCard
			class-name="one-on-one-list__header"
		/>
		<TeamingScroller
			class-name="one-on-one-list__teaming-scroller"
			:items="oneOnOnes"
			:item-size="76"
			@scrollThresholdReached="$emit( `more` )"
		>
			<template v-slot:default="{ item: oneOnOne }">
				<OneOnOneListSkeletonCard v-if="oneOnOne.skeleton" />
				<OneOnOneListCard
					v-else
					class-name="one-on-one-list__card"
					:one-on-one="oneOnOne"
					v-on="bubble( `favorite`, `unfavorite`, `navTo` )"
				/>
			</template>
		</TeamingScroller>
	</div>
</template>

<script>
import EventsMixin from "../../mixins/EventsMixin";
import OneOnOneListCard from "./OneOnOneListCard";
import OneOnOneListHeaderCard from "./OneOnOneListHeaderCard";
import OneOnOneListSkeletonCard from "./OneOnOneListSkeletonCard";
import TeamingScroller from "../TeamingScroller";

export default {
	name: "OneOnOneList",
	mixins: [ EventsMixin, ],
	components: {
		OneOnOneListCard,
		OneOnOneListHeaderCard,
		TeamingScroller,
		OneOnOneListSkeletonCard,
	},
	emits: [
		"favorite",
		"unfavorite",
		"navTo",
		"more",
	],
	props: {
		className: {
			type: String,
			default: "",
		},
		oneOnOnes: {
			type: Array,
			required: true,
		},
	},
	computed: {
		classes() {
			return {
				"one-on-one-list": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.one-on-one-list {
	padding-bottom: 1rem;
}

.one-on-one-list__header {
	display: none;
	margin-bottom: 1rem;

	@include for-size('md') {
		display: flex;
	}
}

.one-on-one-list__card {
	//margin-bottom: 1rem;
}
</style>

<style lang="scss">
// Not sure why this is necessary
.one-on-one-list__teaming-scroller.ready {
	padding-bottom: 1rem !important;

	@include for-size('md') {
		padding-bottom: 2rem !important;
	}
}
</style>
